const _ = require("lodash")
const xss = require("xss")

const filterXss = new xss.FilterXSS({
    whiteList: {
        p: ["style", "class"],
        br: [],
        b: ["style", "class"], strong: ["style", "class"], i: ["style", "class"], em: ["style", "class"], u: ["style", "class"], s: ["style", "class"], strike: ["style", "class"], sub: ["style", "class"], sup: ["style", "class"],
        h1: [], h2: [], h3: [], h4: [], h5: [], h6: [],
        blockquote: [],
        ul: ["class"], ol: ["class"], li: ["class"],
        a: ["href", "target", "rel"],
        span: ["style", "class"],
        div: ["style", "class"],
        img: ["src", "alt", "width", "height", "style", "class"],
        table: ["style", "class"],
        thead: [], tbody: [],
        tr: [],
        td: ["style", "class", "colspan", "rowspan"],
        th: ["style", "class", "colspan", "rowspan"]
    },
    stripIgnoreTag: true,
    stripIgnoreTagBody: ["script", "style"]
})

const sanitizeHtml = html => {
    if (typeof html !== "string") return html
    return filterXss.process(html)
}

// Walks an object using its model's viewMap field definitions and sanitizes
// every field that can carry user-authored HTML (richTextEditor, conversation
// messages), recursing into nested accordion subforms along the way.
const sanitizeUserHtmlFields = (value, formFields) => {
    if (!formFields || value == null) return

    formFields.forEach(field => {
        if (!field || !field.path) return

        const current = value[field.path]
        if (current == null) return

        if (field.type === "richTextEditor") {
            if (typeof current === "string") {
                value[field.path] = sanitizeHtml(current)
            }
            return
        }

        if (field.type === "conversation") {
            if (Array.isArray(current)) {
                current.forEach(message => {
                    if (message && typeof message.text === "string") {
                        message.text = sanitizeHtml(message.text)
                    }
                })
            }
            return
        }

        const nestedFields = _.get(field, "viewMap.form.fields")
        if (!nestedFields) return

        if (Array.isArray(current)) {
            current.forEach(item => sanitizeUserHtmlFields(item, nestedFields))
        } else if (typeof current === "object") {
            sanitizeUserHtmlFields(current, nestedFields)
        }
    })
}

module.exports = {sanitizeHtml, sanitizeUserHtmlFields}